import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { AuthProvider } from './auth/AuthContext';
import { ThemeModeProvider } from './theme/ThemeModeContext';
import { DateTimeFormatProvider } from './preferences/DateTimeFormatContext';
import { NavigationProvider } from './navigation/NavigationContext';
import { Layout } from './components/Layout';
import { RequireAuth } from './components/RequireAuth';
import { Landing } from './pages/Landing';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Dashboard } from './pages/Dashboard';
import { Explore } from './pages/Explore';
import { CarDetail } from './pages/CarDetail';
import { NewCar } from './pages/NewCar';
import { EditCar } from './pages/EditCar';
import { NewActivity } from './pages/NewActivity';
import { Events } from './pages/Events';
import { EventDetail } from './pages/EventDetail';
import { Bazaar } from './pages/Bazaar';
import { BazaarDetail } from './pages/BazaarDetail';
import { NewBazaarItem } from './pages/NewBazaarItem';
import { Forum } from './pages/Forum';
import { NewForumThread } from './pages/NewForumThread';
import { ForumThreadDetail } from './pages/ForumThreadDetail';
import { Profile } from './pages/Profile';
import { UserProfile } from './pages/UserProfile';
import { Inbox } from './pages/Inbox';
import { ConversationView } from './pages/ConversationView';
import { Garage } from './pages/Garage';
import { GarageCarDashboard } from './pages/GarageCarDashboard';
import { MyContributions } from './pages/MyContributions';
import { StaticPage } from './pages/StaticPage';

function App() {
  return (
    <ThemeModeProvider>
      <DateTimeFormatProvider>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={5000}
      >
      <BrowserRouter>
        <NavigationProvider>
          <AuthProvider>
            <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              <Route path="/explore" element={<Explore />} />
              <Route path="/cars/:slugId" element={<CarDetail />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:slugId" element={<EventDetail />} />
              <Route path="/users/:id" element={<UserProfile />} />
              <Route path="/bazaar" element={<Bazaar />} />
              <Route path="/bazaar/:slugId" element={<BazaarDetail />} />
              <Route path="/forum" element={<Forum />} />
              <Route path="/forum/threads/:slugId" element={<ForumThreadDetail />} />

              <Route element={<RequireAuth />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/cars/new" element={<NewCar />} />
                <Route path="/cars/:slugId/edit" element={<EditCar />} />
                <Route path="/activities/new" element={<NewActivity />} />
                <Route path="/bazaar/new" element={<NewBazaarItem />} />
                <Route path="/forum/new" element={<NewForumThread />} />
                <Route path="/inbox" element={<Inbox />} />
                <Route path="/inbox/:conversationId" element={<ConversationView />} />
                <Route path="/garage" element={<Garage />} />
                <Route path="/garage/:slugId" element={<GarageCarDashboard />} />
                <Route path="/contributions" element={<MyContributions />} />
                <Route path="/profile" element={<Profile />} />
              </Route>

              <Route path="/:slug" element={<StaticPage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </AuthProvider>
        </NavigationProvider>
      </BrowserRouter>
      </SnackbarProvider>
      </DateTimeFormatProvider>
    </ThemeModeProvider>
  );
}

export default App;
